// Redux/actions/departmentActions.js
import API from "../../../api.js";
import {
  DEPARTMENT_REQUEST,
  DEPARTMENT_SUCCESS,
  DEPARTMENT_FAIL,
  DEPARTMENT_ADD_REQUEST,
  DEPARTMENT_ADD_SUCCESS,
  DEPARTMENT_ADD_FAIL,
  DEPARTMENT_ADD_RESET,
  DEPARTMENT_DELETE_REQUEST,
  DEPARTMENT_DELETE_SUCCESS,
  DEPARTMENT_DELETE_FAIL,
  DEPARTMENT_DELETE_RESET,
} from "../../constants/adminConstants/departmentConstants.js";

// ✅ Fetch all departments
export const listDepartments = () => async (dispatch) => {
  try {
    dispatch({ type: DEPARTMENT_REQUEST });
    const { data } = await API.get("/admin/departments");
    dispatch({ type: DEPARTMENT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DEPARTMENT_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

// ✅ Add a department
export const addDepartment = (name) => async (dispatch) => {
  try {
    dispatch({ type: DEPARTMENT_ADD_REQUEST });
    await API.post("/admin/departments", { name });
    dispatch({ type: DEPARTMENT_ADD_SUCCESS });

    // Reset success after a short delay
    setTimeout(() => dispatch({ type: DEPARTMENT_ADD_RESET }), 500);
  } catch (error) {
    dispatch({
      type: DEPARTMENT_ADD_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

// ✅ Delete a department
export const deleteDepartment = (id) => async (dispatch) => {
  try {
    dispatch({ type: DEPARTMENT_DELETE_REQUEST });
    await API.delete(`/admin/departments/${id}`);
    dispatch({ type: DEPARTMENT_DELETE_SUCCESS });

    // Reset success after a short delay
    setTimeout(() => dispatch({ type: DEPARTMENT_DELETE_RESET }), 500);
  } catch (error) {
    dispatch({
      type: DEPARTMENT_DELETE_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};
